import { Section } from "Components/Section";
import React from "react";
import { serverConstants } from "Shared/Constants";
import { LcpAppPageWrapper } from "./LcpWorkflowPageWrapper";

export function ApplicationNotFoundPage() {
  return (
    <LcpAppPageWrapper documentTitle="Application Not Found">
      <Section title="Application Not Found">
        This application could not be found.
        <nav style={{ textAlign: "center", marginTop: "1em" }}>
          <a href={serverConstants.StaticSiteUrl}>
            Return to {serverConstants.StaticSiteHost}
          </a>
        </nav>
      </Section>
    </LcpAppPageWrapper>
  );
}
